import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import styles from './Selection.module.sass'
import Icon from '../../../components/Icon'
import { prepareItems } from '../../../adapters/api'
import Player from '../../../components/Player'
import config from '../../../config'

const Selection = ({ items, newest, users }) => {
  const [nft, setNft] = useState([])
  const [authors, setAuthors] = useState([])

  useEffect(() => {
    items = prepareItems(items, users)
    setNft(items)

    newest = prepareItems(newest, users)
    console.log('newest', newest)
    setAuthors(newest)
  }, [items, newest, users])

  return (
    <div className={cn('section-pb', styles.section)}>
      <div className={cn('container', styles.container)}>
        <div className={styles.row}>
          <div className={styles.col}>
            {nft && nft.map((x, index) => index === 0 && (
              <Link className={styles.card} to={'/item/' + x.seo_url} key={index}>
                <div className={styles.preview}>
                  <Player item={x} sizes={{ h: 864, w: 896 }}/>
                </div>
                <div className={styles.head}>
                  <div className={styles.line}>
                    <div className={styles.avatar}>
                      <img src={x.owner.avatar ?? ''} alt="Avatar"/>
                    </div>
                    <div className={styles.description}>
                      <div className={styles.title}>{x.name}</div>
                      <div className={styles.counter}>{x.owner.username}</div>
                    </div>
                  </div>
                  <div className={styles.box}>
                    <div className={styles.content}>Price</div>
                    <div className={styles.price}>{x.ether_price}&nbsp;{config.symbolName}</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className={styles.col}>
            {nft && nft.map((x, index) => index > 0 && (
              <Link className={styles.item} to={'/item/' + x.seo_url} key={index}>
                <div className={styles.preview}>
                  <Player item={x} sizes={{ h: 148, w: 160 }}/>
                </div>
                <div className={styles.description}>
                  <div className={styles.title}>{x.name}</div>
                  <div className={styles.line}>
                    <div className={styles.avatar}>
                      <img src={x.owner.avatar ?? ''} alt="Avatar"/>
                    </div>
                    <div className={styles.content}>{x.owner.username}</div>
                  </div>
                  <div className={styles.price}>{x.ether_price}&nbsp;{config.symbolName}</div>
                  <button
                    className={cn(
                      'button-stroke button-small',
                      styles.button
                    )}
                  >
                    Buy
                  </button>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <div className={styles.sidebar}>
          <div className={styles.info}>
            Latest lots from creators{' '}<span className={styles.smile} role="img"
                                                aria-label="fire">🔥</span>
          </div>
          <div className={styles.list}>
            {authors && authors.map((x, index) => (
              <div className={styles.user} key={index}>
                <Link className={styles.button} to={'/profile/' + (x.owner.link || x.owner.address)}>
                  <div className={styles.avatar}>
                    <img src={x.owner.avatar ?? ''} alt="Avatar"/>
                  </div>
                  <div className={styles.description}>
                    <div className={styles.name}>{x.owner.username}</div>
                    <div className={styles.money}>{x.ether_price}&nbsp;{config.symbolName}</div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
          <Link
            className={cn('button-stroke button-small', styles.button)}
            to="/search"
          >
            <span>Discover more</span>
            <Icon name="arrow-next" size="10"/>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Selection
